import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxTaskReportComponent } from '@go-modules/components/task-report/task-report.component';

export const ngxTaskReportModule = angular.module('ngxTaskReportModule', [])
	.directive('ngxTaskReport', downgradeComponent({ component: NgxTaskReportComponent }))
	.name;
